module.exports = __webpack_public_path__ + "img/title.a93c8794.png";